// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3nAvL","linesWrapper":"styles_linesWrapper__2L7-Y","ellipsis":"styles_ellipsis__1Ujuz","updateButton":"styles_updateButton__uyw8b"};